import { initializeTeslaLookupHistoryStore } from "@lyteflo/utils";

export const initPortalWebTeslaLookupHistoryStore = () => {
  initializeTeslaLookupHistoryStore(window.localStorage);
};
